import React from 'react';
import api from '../../utils/api';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const Whitelist = () => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [ip, setIp] = React.useState('');
  const [label, setLabel] = React.useState('');
  const [error, setError] = React.useState(null);
  const [notAdmin, setNotAdmin] = React.useState(false);
  
  // للـ Modal
  const [editModal, setEditModal] = React.useState(false);
  const [editingRow, setEditingRow] = React.useState(null);
  const [editIp, setEditIp] = React.useState('');
  const [editLabel, setEditLabel] = React.useState('');
  const [editIsActive, setEditIsActive] = React.useState(true);
  const [editIsProtected, setEditIsProtected] = React.useState(false);

  const load = React.useCallback(() => {
    setLoading(true);
    api.get('/whitelist-ips')
      .then(res => {
        const data = Array.isArray(res.data?.data) ? res.data.data : (Array.isArray(res.data) ? res.data : []);
        setRows(data);
        setError(null);
        setNotAdmin(false);
      })
      .catch(err => {
        const status = err?.response?.status;
        const msg = err?.response?.data?.message || 'حدث خطأ';
        // نميز بين حظر IP وبين نقص صلاحيات
        if (status === 403 && msg.toLowerCase().includes('admin')) {
          setNotAdmin(true);
          setError('هذه الصفحة مخصصة للمشرف (Admin) فقط.');
        } else {
          setError(msg);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  React.useEffect(() => { load(); }, [load]);

  const onCreate = (e) => {
    e.preventDefault();
    if (!ip) return;
    if (notAdmin) return;
    api.post('/whitelist-ips', { ip_address: ip, label })
      .then(() => { setIp(''); setLabel(''); load(); })
      .catch(err => setError(err?.response?.data?.errors ? JSON.stringify(err.response.data.errors) : (err?.response?.data?.message || 'تعذر الإضافة')));
  };

  const onToggle = (row) => {
    if (notAdmin) return;
    api.post(`/whitelist-ips/${row.id}/toggle`)
      .then(() => load())
      .catch(err => setError(err?.response?.data?.message || 'تعذر التغيير'));
  };

  const onDelete = (row) => {
    if (!window.confirm('حذف العنوان؟')) return;
    if (notAdmin) return;
    api.delete(`/whitelist-ips/${row.id}`)
      .then(() => load())
      .catch(err => setError(err?.response?.data?.message || 'تعذر الحذف'));
  };

  const onEditLabel = (row) => {
    setEditingRow(row);
    setEditIp(row.ip_address);
    setEditLabel(row.label || '');
    setEditIsActive(!!row.is_active);
    setEditIsProtected(!!row.is_protected);
    setEditModal(true);
  };

  const onSaveEdit = () => {
    if (!editingRow || notAdmin) return;
    api.put(`/whitelist-ips/${editingRow.id}`, { 
      ip_address: editIp, 
      label: editLabel,
      is_active: editIsActive,
      is_protected: editIsProtected
    })
      .then(() => {
        setEditModal(false);
        setEditingRow(null);
        load();
      })
      .catch(err => setError(err?.response?.data?.message || 'تعذر التعديل'));
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-0">القائمة البيضاء للـ IPs</h4>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-8">
          <form className="mb-3" onSubmit={onCreate}>
            <div className="row g-2">
              <div className="col-md-4">
                <input value={ip} onChange={e=>setIp(e.target.value)} type="text" className="form-control" placeholder="عنوان IP" required disabled={notAdmin} />
              </div>
              <div className="col-md-4">
                <input value={label} onChange={e=>setLabel(e.target.value)} type="text" className="form-control" placeholder="وصف (اختياري)" disabled={notAdmin} />
              </div>
              <div className="col-md-4">
                <button className="btn btn-primary" type="submit" disabled={notAdmin}>إضافة</button>
              </div>
            </div>
          </form>
          {error ? <div className="alert alert-danger py-2">{error}</div> : null}
          {notAdmin ? (
            <div className="alert alert-warning">لا تملك صلاحية الإدارة. الرجاء تسجيل الدخول بحساب أدمن لإدارة القائمة البيضاء.</div>
          ) : null}
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              {loading ? (
                <div>جاري التحميل...</div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped align-middle">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>عنوان IP</th>
                        <th>الوصف</th>
                        <th>الحالة</th>
                        <th>محمي</th>
                        <th>الإجراءات</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((r, idx) => (
                        <tr key={r.id}>
                          <td>{idx + 1}</td>
                          <td>{r.ip_address}</td>
                          <td>{r.label || '-'}</td>
                          <td>
                            {r.is_active ? <span className="badge bg-success fs-6">نشط</span> : <span className="badge bg-secondary fs-6">معطّل</span>}
                          </td>
                          <td>{r.is_protected ? 'نعم' : 'لا'}</td>
                          <td className="d-flex gap-2">
                            <button className="btn btn-sm btn-outline-primary" disabled={!!r.is_protected || notAdmin} onClick={()=>onToggle(r)}>
                              {r.is_active ? 'تعطيل' : 'تفعيل'}
                            </button>
                            <button className="btn btn-sm btn-outline-secondary" disabled={!!r.is_protected || notAdmin} onClick={()=>onEditLabel(r)}>تعديل</button>
                            <button className="btn btn-sm btn-outline-danger" disabled={!!r.is_protected || notAdmin} onClick={()=>onDelete(r)}>حذف</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal للتعديل */}
      <Modal isOpen={editModal} toggle={() => setEditModal(false)}>
        <ModalHeader toggle={() => setEditModal(false)}>
          تعديل عنوان IP
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <label className="form-label">عنوان IP</label>
            <input 
              type="text" 
              className="form-control" 
              value={editIp} 
              onChange={e => setEditIp(e.target.value)}
              disabled={editingRow?.is_protected}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">الوصف (اختياري)</label>
            <input 
              type="text" 
              className="form-control" 
              value={editLabel} 
              onChange={e => setEditLabel(e.target.value)}
              autoComplete="off"
            />
          </div>
          <div className="mb-3">
            <label className="form-label d-block">الحالة</label>
            <div className="form-check form-switch">
              <input 
                className="form-check-input" 
                type="checkbox" 
                checked={editIsActive}
                onChange={e => setEditIsActive(e.target.checked)}
                disabled={editingRow?.is_protected}
                id="editActiveSwitch"
              />
              <label className="form-check-label" htmlFor="editActiveSwitch">
                {editIsActive ? 'نشط' : 'معطّل'}
              </label>
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">محمي من التعديل/الحذف</label>
            <div className="form-check form-switch">
              <input 
                className="form-check-input" 
                type="checkbox" 
                checked={editIsProtected}
                onChange={e => setEditIsProtected(e.target.checked)}
                id="editProtectedSwitch"
              />
              <label className="form-check-label" htmlFor="editProtectedSwitch">
                {editIsProtected ? 'نعم (محمي)' : 'لا'}
              </label>
            </div>
          </div>
          {editingRow?.is_protected && (
            <div className="alert alert-warning mb-0">
              <i className="mdi mdi-alert"></i> هذا العنوان محمي، بعض الخيارات معطلة
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setEditModal(false)}>
            إلغاء
          </Button>
          <Button color="primary" onClick={onSaveEdit}>
            حفظ
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Whitelist;
